import script from "./cnt-table_privacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-table_privacy.vue?vue&type=script&lang=ts&setup=true"

import "stylesheets/lib/_cnt-table_privacy.scss?vue&type=style&index=0&id=67866a99&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67866a99"]])

export default __exports__